import fontkit from '@pdf-lib/fontkit';
import { PDFDocument, rgb } from 'pdf-lib';
import { LATO_FONT, LATO_BOLD_FONT } from '/src/fonts/LatoBase64';



/*
 * for paid report downloads, add user email on each page of the report
 * https://pdf-lib.js.org/
 */
export const addUserEmailToReport = async (url, filename, user) => {

    // get file and initialize custom font 'Lato'
    const report   = await fetch(url).then(res => res.arrayBuffer());
    const pdfDoc   = await PDFDocument.load(report);
    pdfDoc.registerFontkit(fontkit);
    const latoFont = await pdfDoc.embedFont(LATO_FONT);
    const latoBoldFont = await pdfDoc.embedFont(LATO_BOLD_FONT);

    // set file metadata
    const creator = 'MAGNiTT';
    pdfDoc.setTitle(filename, { showInWindowTitleBar: true });
    pdfDoc.setAuthor(creator);
    pdfDoc.setProducer(creator); // avoid exposing the library name

    // add user email on each page
    const fontSize   = 9; 
    const text       = `Not for distribution, ${user.email}`;
    const textWidth  = latoFont.widthOfTextAtSize(text, fontSize);
    const pages      = pdfDoc.getPages();
    const pageSize   = pages[0].getSize();
    const layoutType = 'right';
    const textColor  = rgb(54 / 255, 69 / 255, 79 / 255); // pdf-lib requires dividing rgb values by 255 (charcoal #36454F)
    const XYCoords   = getWatermarkXYCoordinates(layoutType, pageSize, textWidth);

    // add user name and email on cover page
    const coverFontSize   = 14; 
    const coverText1      = `Downloaded for ${user.full_name}, `;
    const coverText2      = `${user.email}`;
    const coverTextWidth  = latoFont.widthOfTextAtSize(coverText1, coverFontSize);
    const coverLayoutType = 'left';
    const coverXYCoords   = getWatermarkXYCoordinates(coverLayoutType, pageSize, coverTextWidth);
    const emailXYCoords   = { x: coverXYCoords.x + coverTextWidth, y: coverXYCoords.y }

    pages.map((page, index) => {
        if (index == 0) { // cover page
            page.drawText(coverText1, {
                ...coverXYCoords,
                size: coverFontSize,
                font: latoFont,
                color: textColor 
            })
            page.drawText(coverText2, {
                ...emailXYCoords,
                size: coverFontSize,
                font: latoBoldFont,
                color: textColor
            })
        } else if (index == 1) { // table of contents
            return;
        } else { // remaining pages 
            page.drawText(text, {
                ...XYCoords,
                size: fontSize,
                font: latoFont,
                color: textColor
            })
        }
    });

    const pdfBytes = await pdfDoc.save(); // serialize to an array of bytes making up a PDF file
    return pdfBytes;

}

// get watermark x & y coordinates for center alignment, left-aligned and right-aligned
// only right-aligned is in use, kept the others in case its needed in future
const getWatermarkXYCoordinates = (layoutType = 'right', pageSize, textWidth) => {
    // note: Y coordinate is counted from page bottom
    const bottomMargin = 25;
    if (layoutType === 'center') {
        return {
            x: ((pageSize.width / 2) - (textWidth / 2)), 
            y: bottomMargin,
        }
    } else if (layoutType === 'left') {
        return {
            x: 60, 
            y: bottomMargin,
        }
    } else if (layoutType === 'right') {
        const rightMargin = 70;
        return {
            x: (pageSize.width - textWidth - rightMargin), 
            y: bottomMargin,
        }
    }
}

/*
 * for paid report downloads, handle direct download
 *
 * its a direct download instead of new tab open, this is the only way to specify blob filename
 * free reports are handled with new tab, can't do direct download as host (aws) is different
 */
export const downloadWatermarkedReport = async (downloadPath, user) => {
    const filename = downloadPath.substring(downloadPath.lastIndexOf('/') + 1);
    const pdfBytes = await addUserEmailToReport(downloadPath, filename, user);

    // download modified file
    const userAgent = window.navigator.userAgent;
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
        const blob = new Blob([pdfBytes], { type: 'application/octet-stream' })
        handleSafariMobileDownload(blob, filename);
    } else {
        const blob = new Blob([pdfBytes], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href  = URL.createObjectURL(blob);
        link.download = filename; // specify blob filename
        link.click();
    }
}

export const handleSafariMobileDownload = (blob, fileName) => {
    const href = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", href);
    link.setAttribute("target", "_blank");
    link.setAttribute("download", fileName);

    const clickEvent = new MouseEvent("click", {
        view: window, bubbles: true, cancelable: false
    });
    link.dispatchEvent(clickEvent);
}